import FlightRecommender from './FlightsRecommender';

export default FlightRecommender;
